import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Route} from '@angular/router';
import {RightsPageFiltersRoutes, RightsRoutes} from '@pages/rights/entities/rights.constants';
import {CtsDistributionFiltersRoutes, CtsDistributionRoutes} from '@pages/cts-distribution/cts-distribution.routes';

/** routes constant
 * @type {Route[]}
 */
const routes: Route[] = [
	{
		path: '',
		redirectTo: 'rights',
		pathMatch: 'full',
	},
	...RightsRoutes,
	...RightsPageFiltersRoutes,
	...CtsDistributionRoutes,
	...CtsDistributionFiltersRoutes,
	{
		path: '**',
		redirectTo: 'rights',
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			useHash: true,
			preloadingStrategy: PreloadAllModules,
			relativeLinkResolution: 'legacy',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
